'use client'

import type { TurnkeyEthersSigner } from '@/utils/TurnkeyEthersAdapter'
import type { SolanaSigner } from '@account-kit/signer'
import type { Connection } from '@solana/web3.js'
import { createContext, useContext } from 'react'
import type { PublicClient, WalletClient } from 'viem'

export interface WalletContextType {
	// Polygon (EVM)
	eoaAddress: `0x${string}` | undefined
	walletClient: WalletClient | null
	publicClient: PublicClient | null
	ethersSigner: TurnkeyEthersSigner | null
	// Solana
	solanaAddress: string | undefined
	solanaSigner: SolanaSigner | null
	solanaConnection: Connection | null
	// Status
	isReady: boolean
	isSolanaReady: boolean
	authenticated: boolean
}

export const WalletContext = createContext<WalletContextType>({
	eoaAddress: undefined,
	walletClient: null,
	publicClient: null,
	ethersSigner: null,
	solanaAddress: undefined,
	solanaSigner: null,
	solanaConnection: null,
	isReady: false,
	isSolanaReady: false,
	authenticated: false,
})

export function useWallet() {
	return useContext(WalletContext)
}
